import React from "react";
import Modal from "src/admin/modal";
import { IDispatchClient, useDashboardConfig } from "./dispatch_api_client";
import { formatTime } from "./formatting";

type AddDriverControlProps = {
  driverId: number;
  driverName: string;
  shiftTimes: Date[];
  requireExpectedEnd: boolean;
};

const fillExpectedEndOptions = (select: HTMLSelectElement, shiftTimes: Date[]) => {
  const now = new Date();
  const placeholder = new Option("Expected to finish at…", "");
  const options = shiftTimes
    .filter(time => time > now)
    .map(time => new Option(formatTime(time), time.toISOString()));

  select.replaceChildren(placeholder, ...options);
};

const showAddDriverDetailsModal = (apiClient: IDispatchClient, driverId: number, driverName: string, shiftTimes: Date[]) => {
  Modal.show({
    title: `Add ${driverName}`,
    content: `
      <div class="field">
        <label class="label">Expected to finish at</label>
        <div class="control">
          <div class="select">
            <select aria-label="Expected to finish at" data-form-validator-target="requiredField"></select>
          </div>
        </div>
      </div>`,
    acceptButtonLabel: "Add",
    focus: "select",
    onShow: (content: HTMLElement) => {
      fillExpectedEndOptions(content.querySelector("select")!, shiftTimes);
    },
    onAccept: async (content: HTMLElement) => {
      const select = content.querySelector("select")!;
      if (!select.value) return false;

      const expectedEnd = new Date(select.value);
      if (expectedEnd <= new Date()) {
        fillExpectedEndOptions(select, shiftTimes);
        return false;
      }

      await apiClient.addDriver(driverId, expectedEnd);
    },
  }).catch(() => undefined);
};

const AddDriverControl = ({ driverId, driverName, shiftTimes, requireExpectedEnd }: AddDriverControlProps) => {
  const { apiClient } = useDashboardConfig();

  const handleAdd = async () => {
    if (requireExpectedEnd) {
      showAddDriverDetailsModal(apiClient, driverId, driverName, shiftTimes);
    } else {
      await apiClient.addDriver(driverId);
    }
  };

  return (
    <div className="has-text-right is-flex-grow-1 ml-1">
      <button className="button is-small is-success" onClick={() => void handleAdd()}>Add</button>
    </div>
  );
};

export { AddDriverControl };
